/**
 *  Paging composition for contractSpecs
 */
import assetActionCreators from '../../actions/assetActionCreators';
import pagingComposition from '../common/pagingTable/pagingComposition';
export default pagingComposition('asset', assetActionCreators, {
  AssetID: 'name',
  Alias: 'alias'
});